import { CORE, gateway } from '../../api';

export function buscarEmailProcessoByIdProcessoAndTipoDestinatarioService(idProcesso, tipoDestinatario) {
  return gateway.get(`${CORE}/processos/${idProcesso}/documento-email?tipoDestinatarioEnum=${tipoDestinatario}`);
}
